module.exports = __webpack_public_path__ + "img/jd_e.60602faf.png";